module.exports = __webpack_public_path__ + "img/Admobile.20be7196.jpg";